// Copyright (c) 2016 Deere & Company

import {updateClaimModalMode, updateCreateClaimModalVisibility} from './create-claim-modal-visibility';
import actions from '../../action-list';
import {createAttachmentClaim} from './validate-claim';
import {getUpdatedAttachmentClaim} from '../services/update-attachment-claim';
import {isActionResetFormValidation} from '../../shared/services/claim-shared-helper';

export const updateSelectedAction = selectedAction =>

    (dispatch, getState) => {

        const updatedClaim = getUpdatedAttachmentClaim(getState().claims.attachment.claim, selectedAction);

        const updateModalVisibility = () => {

            updateClaimModalMode('CREATE')(dispatch);
            updateCreateClaimModalVisibility(true)(dispatch);

        };

        const updateIsEditable = () => {

            dispatch({
                isEditable: true,
                type: actions.UPDATE_CLAIM_ATTACHMENT_IS_EDITABLE
            });

            dispatch({
                type: actions.REVISE_CLAIM_ATTACHMENT
            });

        };

        if (isActionResetFormValidation(selectedAction.id)) {

            dispatch({
                type: actions.RESET_CLAIM_ATTACHMENT_FORM_VALIDATION
            });

        }

        const selectedActionIdTypes = {
            CRT: updateModalVisibility,
            REVISE: updateIsEditable
        };

        const updateType = selectedActionIdTypes[selectedAction.id];

        return updateType ? updateType() : createAttachmentClaim(updatedClaim)(dispatch, getState);

    };



// WEBPACK FOOTER //
// ./src/claim/attachment/action-creators/update-selected-action.js